import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useMarketStore } from '../store/marketStore';
import StockTable from '../components/StockTable';

/**
 * 股票看板页 — 全市场行情
 * 展示全A股行情 + 搜索 + 排序
 */
export default function MarketPage() {
  const {
    quotes,
    total,
    loading,
    sort,
    order,
    search,
    page,
    fetchQuotes,
    setPage,
    setSort,
    setSearch,
    startPolling,
    stopPolling,
  } = useMarketStore();

  useEffect(() => {
    fetchQuotes();
    startPolling();
    return () => stopPolling();
  }, [fetchQuotes, startPolling, stopPolling]);

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        股票看板
      </Typography>

      <StockTable
        quotes={quotes}
        total={total}
        loading={loading}
        sort={sort}
        order={order}
        onSortChange={setSort}
        search={search}
        onSearchChange={setSearch}
        rowHeight={36}
        maxHeight={700}
      />

      {/* 简单分页 */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, gap: 2 }}>
        <Box
          component="button"
          onClick={() => setPage(page - 1)}
          disabled={page <= 1}
          sx={{
            px: 2,
            py: 0.5,
            border: '1px solid',
            borderColor: page <= 1 ? 'grey.300' : 'primary.main',
            color: page <= 1 ? 'grey.400' : 'primary.main',
            bgcolor: 'transparent',
            borderRadius: 1,
            cursor: page <= 1 ? 'not-allowed' : 'pointer',
            fontSize: 13,
          }}
        >
          上一页
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2, fontSize: 13 }}>
          第 {page} 页 / 共 {Math.max(1, Math.ceil(total / 50))} 页
        </Box>
        <Box
          component="button"
          onClick={() => setPage(page + 1)}
          disabled={page * 50 >= total}
          sx={{
            px: 2,
            py: 0.5,
            border: '1px solid',
            borderColor: page * 50 >= total ? 'grey.300' : 'primary.main',
            color: page * 50 >= total ? 'grey.400' : 'primary.main',
            bgcolor: 'transparent',
            borderRadius: 1,
            cursor: page * 50 >= total ? 'not-allowed' : 'pointer',
            fontSize: 13,
          }}
        >
          下一页
        </Box>
      </Box>
    </Box>
  );
}
